import React, { Component } from "react";
import { connect } from "react-redux";
import moment from "moment";
import PropTypes from "prop-types";
import { Slider } from "antd";
import {
  getDataIniciAsMoment,
  getDataFiAsMoment,
  getPeticioVisualitzacioEnCurs
} from "../../reducers";
import { omplirDataSeleccionadaVisualitzacio } from "../../actions";
import { FORMAT_YYYYMMDD } from "../../constantsObservacions";
import { diasEntreDates, MASCARA_ISO_DIA } from "../../utils/dates";

class VisualitzacioMapaSlider extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mapDiasSlider: {}
    };
  }

  crearMapDiasSlider = arrayDias => {
    let mapDias = {};

    arrayDias.forEach((dia, index) => {
      mapDias[index + 1] = dia;
    });

    return mapDias;
  };

  shouldComponentUpdate(nextProps) {
    return nextProps.isPeticioVisEnCurs !== this.props.isPeticioVisEnCurs;
  }

  componentDidMount() {
    this.onChangeData();
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.isPeticioVisEnCurs !== this.props.isPeticioVisEnCurs) {
      const novaDataInici = moment(nextProps.dataInici).format(FORMAT_YYYYMMDD);
      const novaDataFi = moment(nextProps.dataFi).format(FORMAT_YYYYMMDD);
      const arraydiasEntreDatesSlider = diasEntreDates(
        novaDataInici,
        novaDataFi,
        MASCARA_ISO_DIA
      );

      const mapDiasSlider = this.crearMapDiasSlider(arraydiasEntreDatesSlider);
      this.setState({ mapDiasSlider: mapDiasSlider });
    }
  }

  onChangeData = () => {
    const { dataInici, dataFi } = this.props;
    const arraydiasEntreDatesSlider = diasEntreDates(
      dataInici,
      dataFi,
      MASCARA_ISO_DIA
    );

    const mapDiasSlider = this.crearMapDiasSlider(arraydiasEntreDatesSlider);
    this.setState({ mapDiasSlider: mapDiasSlider });
  };

  render() {
    const { dataInici, dataFi } = this.props;

    const onChangeDia = dia => {
      this.setState({ diaSelected: dia });
      const data = moment(this.state.mapDiasSlider[dia], FORMAT_YYYYMMDD);
      this.props.omplirDataSeleccionadaVisualitzacio(data);
    };

    const arraydiasEntreDatesSlider = diasEntreDates(
      dataInici,
      dataFi,
      MASCARA_ISO_DIA
    );

    return (
      <div>
        <Slider
          defaultValue={1}
          tooltipVisible={false}
          step={1}
          dots={false}
          onChange={onChangeDia}
          max={arraydiasEntreDatesSlider.length}
          min={1}
        />
      </div>
    );
  }
}

VisualitzacioMapaSlider.propTypes = {
  dataInici: PropTypes.object.isRequired,
  dataFi: PropTypes.object.isRequired,
  isPeticioVisEnCurs: PropTypes.bool
};

const mapStateToProps = state => ({
  dataInici: getDataIniciAsMoment(state),
  dataFi: getDataFiAsMoment(state),
  isPeticioVisEnCurs: getPeticioVisualitzacioEnCurs(state)
});

export default connect(mapStateToProps, {
  omplirDataSeleccionadaVisualitzacio
})(VisualitzacioMapaSlider);
